import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScCoverflowSliderTemplate = styled.div<{
  backgroundUrl: string;
}>`
  font-family: 'Work Sans';
  position: relative;
  font-weight: 700;
  color: #ffffff;
  background: url(${({ backgroundUrl }) => backgroundUrl}) no-repeat top
    center / cover;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: clip;
  min-height: 100vh;
  min-height: 100dvh;
  background-attachment: fixed;

  @media (${device.mobile}) {
    justify-content: flex-start;
  }

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
  }

  & img {
    display: block;
    max-width: 100%;
    height: auto;
  }

  & > .content,
  & > .logo-wrapper {
    position: relative;
    z-index: 2;
  }

  & > .logo-wrapper {
    @media (${device.mobile}) {
      margin-bottom: 38px;
      & a {
        width: 121px;
        height: 32px;
      }
    }
  }

  & > .content {
    margin-top: 80px;
    width: min(100%, 1280px);
    margin-inline: auto;
    @media (${device.mobile}) {
      margin-top: 45px;
    }
  }

  & .slider {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    position: relative;

    & > .slider-container {
      position: relative;
      width: 100%;
      height: 460px;
      display: flex;
      justify-content: center;
      align-items: center;
      perspective: 1200px;

      @media (${device.mobile}) {
        height: 450px;
      }

      & > div {
        width: 380px;
        height: 460px;
        position: absolute;
        transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        transform-origin: center center;
        cursor: pointer;

        &:not(.active):hover {
          filter: brightness(1.3);
        }

        @media (${device.mobile}) {
          width: 332px;
          height: 450px;
        }

        & > div {
          height: 100%;
        }
      }
    }
  }

  & .controls {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 16px;
    margin-top: 16px;
    margin-bottom: 32px;

    @media (${device.mobile}) {
      margin-top: 16px;
      margin-bottom: 24px;
    }

    & > .arrow {
      border: none;
      outline: none;
      background: transparent;
      cursor: pointer;

      &.prev > img {
        transform: rotateY(180deg);
      }
    }

    & > .dots {
      display: flex;
      gap: 4px;

      .dot {
        width: 8px;
        aspect-ratio: 1;
        border: none;
        outline: none;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.3);
        cursor: pointer;
        transition:
          transform 0.3s ease,
          background-color 0.3s ease;

        &:hover:not(:disabled) {
          background-color: rgba(255, 255, 255, 0.5);
          transform: scale(1.2);
        }

        &.active-dot {
          background-color: #ffffff;
        }

        &:disabled {
          cursor: not-allowed;
        }
      }
    }
  }

  & .footer {
    position: relative;
    margin-inline: auto;
    padding-bottom: 24px;
    bottom: 0;
    left: 0;
    z-index: 2;
  }

  & .code-wrapper {
    display: grid;
    place-items: center;
  }

  & .button-wrapper {
    position: relative;
    width: min(100%, 352px);
    margin-inline: auto;
    z-index: 2;

    button {
      font-size: 24px;
    }

    @media (${device.mobile}) {
      margin-inline: none;
      width: 100%;
    }

    @media (${device.mobile}) {
      position: sticky;
      border-radius: 12px;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      bottom: 0px;
      width: 100%;
      height: 72px;
      z-index: 3;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -20px;
        right: -20px;
        bottom: -20px;
        border-radius: inherit;
        backdrop-filter: blur(7px);
        z-index: -1;
      }
    }
  }
`;
